import React from 'react'
import { connect } from 'react-redux'
import { Fade } from '@material-ui/core'
import { IconButton, Collapse, Card, CardHeader, CardContent } from '@material-ui/core'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import { PHCont } from './styled'
import { StdCard } from 'components'
import { ProcessRow } from './ProcessRow'

const CommentHistory = props => {
  const { vmaData } = props
  const [showComment, setShowComment] = React.useState(true)
  return (
    <Card style={{ marginTop: '10px' }}>
      <CardHeader 
        title='Comment History'
        action={
          <IconButton aria-label='Expand' onClick={() => setShowComment(!showComment) }>
            {showComment ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        }
      />
      <Collapse in={showComment}>
        <CardContent>
          {vmaData &&
            vmaData.comments.map((item, i) => {
              let files = vmaData.attachment09.filter(x => x.commentId === item.id)
              return <ProcessRow data={item} files={files} />
            })}
        </CardContent>
      </Collapse>
    </Card>
  )
}

const mapStateToProps = state => {
  return {
    vmaData: state.vendorMaintenance.formData.data
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(CommentHistory)
